export const NOTIFICATION_ACTION_ENUM = {
  VIEW_APPROVE_REJECT: '1',
  VIEW_APPROVE: '2',
  VIEW: '3',
}

export const NOTIFICATION_ENTITY_ENUM = {
  SALE_ORDER: 1,
  PRODUCING_STEP: 2,
  WORK_CENTER: 3,
  ROUTING: 4,
  BOQ: 5,
  MASTER_PLAN: 6,
  MATERIAL_REQUEST_WARNING: 7,
  MANUFACTURING_ORDER: 8,
}
